//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    props: {
      type: Object,
      default: null,
    },
    data: {
      type: Object,
      default: null,
    },
  },
  created() {
    // load pros
  },
  methods: {
    selectOption(option) {
      this.$emit('save', {
        key: 'prosAvailable',
        focusNext: true,
        value: {
          value: option.proId,
          textValue: option.label,
        },
      });
    },
    getOptions() {
      console.log(this.props.prosAvailable);
      return this.props.prosAvailable.map((pro) => ({
        label: pro.name,
        proId: pro.proId,
      }));
    },
  },
};
